import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed } from 'vue'
import shared from '@/micro/shared'

export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

shared.setAppName('admin')

const appName = computed(() => {
  return shared.getAppName()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_router_view, { key: appName.value }, {
            default: _withCtx(({ Component, route }) => [
              (_openBlock(), _createBlock(_KeepAlive, { max: 60 }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  ref: "component",
                  key: route.path
                }))
              ], 1024))
            ]),
            _: 1
          }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})